<template>
	<div class="image-uploader d-flex flex-column">
		<viewer :images="[localData.imageSrc]" v-if="imageViewerVisible" style="position:absolute;width: 1px;height: 1px;left:-20000px">
			<img v-for="src in [localData.imageSrc]" :key="src" :src="src">
		</viewer>
		<v-img :src="localData.imageSrc" class="mb-2" style="cursor: pointer;border-radius: 5px;border:2px dashed grey" :width="settings.image.width" @click.stop="showImagePreview" />
		<input class="d-none" type="file" accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls" @change="onFileChange()" ref="imageUploadcontrol" />
		<div class="buttons d-flex flex-row justify-content-between">
			<v-btn v-if="downloadable" class="ms-2" x-small icon color="green" title="دانلود" @click="downlaodClicked()">
				<div class="d-flex flex-column justify-center">
					<v-icon dark>
						mdi-download
					</v-icon>
					<small>دانلود</small>
				</div>
			</v-btn>
			<v-btn v-if="editable" class="ms-2" x-small icon color="blue" title="انتخاب فایل" @click="selectClicked()">
				<div class="d-flex flex-column justify-center">
					<v-icon dark>
						mdi-upload
					</v-icon>
					<small>آپلود</small>
				</div>
			</v-btn>
			<v-btn v-if="editable" class="ms-2" x-small icon color="pink" title="حذف" @click="deleteClicked()">
				<div class="d-flex flex-column justify-center">
					<v-icon dark>
						mdi-trash-can-outline
					</v-icon>
					<small>حذف</small>
				</div>
			</v-btn>
		</div>
		<div class="mt-2" v-if="localData.imageName && settings.showFileName">{{ localData.imageName }}</div>
	</div>
</template>

<script>
	import _ from 'lodash'
	import toast from '@/util/toast'
	import PdfIcon from '@/assets/pdf-icon.svg'
	import ZipIcon from '@/assets/zip-icon.svg'
	import XlsIcon from '@/assets/xls-icon.svg'

	export default {
		name: 'ImageUploader',
		props: {
			options: { type: Object },
			value: { type: String },
			fileUrl: { type: String },
			errorImage: { type: String, default: '' },
			downloadFileName: { type: String, default: '' },
			downloadable: { type: Boolean, default: true },
			editable: { type: Boolean, default: true }
		},
		mounted() {
			_.merge(this.settings, this.options)
			if (this.fileUrl)
				this.localData.imageSrc = this.setFileIcon()
			else
				this.localData.imageSrc = this.value ? this.value : this.errorImage
		},
		data() {
			return {
				imageViewerVisible: false,
				images: [
					"https://picsum.photos/200/200",
					"https://picsum.photos/300/200",
					"https://picsum.photos/250/200"
				],
				localData: {
					originalImage: null,
					fileUrl: '',
					imageSrc: '',
					imageName: null,
					fileType: ''
				},
				settings: {
					width: 150,
					height: 150,
					maximumFileSize: 3145728, // in bytes 3MB
					showFileName: false,
					image: {
						width: 150,
						height: 150,
						defaultImage: 'person'
					}
				}
			}
		},
		watch: {
			value: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.localData.imageSrc = val ? val : this.errorImage
				}
			},
			fileUrl: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					this.localData.fileUrl = val
					this.localData.imageSrc = this.setFileIcon()
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.extend({}, this.settings, val)
				}
			}
		},
		methods: {
			setFileIcon() {
				if (this.localData.fileUrl?.endsWith('.pdf')) {
					this.localData.fileType = 'pdf'
					return PdfIcon
				}
				else if (this.localData.fileUrl?.endsWith('.zip') || this.localData.fileUrl?.endsWith('.rar')) {
					this.localData.fileType = 'zip'
					return ZipIcon
				}
				else if (this.localData.fileUrl?.endsWith('.xls')) {
					this.localData.fileType = 'xls'
					return XlsIcon
				}
				else if (this.localData.fileUrl?.endsWith('.xlsx')) {
					this.localData.fileType = 'xlsx'
					return XlsIcon
				}
				return this.errorImage
			},
			isExcel(type) {
				return type?.includes('application/vnd.openxmlformats') || type?.includes('spreadsheetml')
			},
			onFileChange() {
				let image = this.$refs.imageUploadcontrol.files[0]
				if (!image) return

				if (image.type !== 'image/jpeg' && image.type !== 'image/png' && image.type !== 'application/pdf' && !this.isExcel(image.type)) {
					return toast.error('فقط فایل های از نوع تصویر و pdf مجاز می باشد.')
				}
				if (image.size >= this.settings.maximumFileSize) { // Check if the file size is under, 3000kb the image size value is in bytes
					return toast.error(`سایز فایل انتخاب شده باید کمتر از ${parseInt(this.settings.maximumFileSize / 1000 / 1000)} مگابایت باشد`)
				}
				this.localData.originalImage = image
				this.localData.fileType = image.type
				this.localData.imageName = image.name
				if (image.type === 'application/pdf') {
					this.localData.fileUrl = ''
					this.localData.imageSrc = PdfIcon
					this.$emit('change')
				} else if (this.isExcel(image.type)) {
					this.localData.fileUrl = ''
					this.localData.imageSrc = XlsIcon
					this.$emit('change')
				} else {
					this.toBase64(image).then((res) => {
						this.localData.imageSrc = res
						this.$emit('input', res)
						this.$emit('change')
					})
				}
			},
			hasFile() {
				return this.$refs.imageUploadcontrol.files.length > 0
			},
			deleteClicked() {
				this.localData.imageSrc = this.errorImage
				this.localData.imageName = ''
				this.localData.fileUrl = ''
				this.$refs.imageUploadcontrol.value = ''
				this.$emit('delete')
				this.$emit('input', '')
			},
			selectClicked() {
				this.$refs.imageUploadcontrol.click()
			},
			getFile() {
				if (this.hasFile())
					return this.$refs.imageUploadcontrol.files[0]
				return null
			},
			getUploadImageData() {
				return this.localData.originalImage
			},
			getUploadImageDataBase64(ignoreOriginal = false) {
				let base64 = ""
				if ((this.localData.originalImage || ignoreOriginal) && this.localData.imageSrc.startsWith('data:')) {
					let replace = this.localData.imageSrc.substring(0, this.localData.imageSrc.indexOf(',') + 1)
					base64 = this.localData.imageSrc.replace(replace, '')
				}
				return base64
			},
			toBase64(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.readAsDataURL(file)
					reader.onload = () => resolve(reader.result)
					reader.onerror = (error) => reject(error)
				})
			},
			downlaodClicked() {
				const extractExtension = (data) => {
					if (data.indexOf('png'))
						return 'png'
					if (data.indexOf('jpg'))
						return 'jpg'
					if (data.indexOf('pdf'))
						return 'pdf'
					if (data.indexOf('xls'))
						return 'xls'
					if (data.indexOf('xlsx'))
						return 'xlsx'
					return 'png'
				}
				if (this.localData.fileUrl) {
					var a = document.createElement("a")
					a.target = '_blank'
					a.href = this.localData.fileUrl + (this.downloadFileName ? `/${this.downloadFileName}.${this.localData.fileType}` : '')
					a.click()
				} else {
					const base64 = this.getUploadImageDataBase64(true)
					if (base64 && this.localData.imageSrc != this.errorImage) {
						var a = document.createElement("a")
						a.href = this.localData.imageSrc
						a.download = `${this.downloadFileName ? this.downloadFileName : 'download'}.${extractExtension(this.localData.imageSrc)}`
						a.click()
					}
				}
			},
			showImagePreview() {
				this.imageViewerVisible = true
				this.$viewerApi({
					images: [this.localData.imageSrc],
				})
			}
		}
	}
</script>

<style>
	.image-uploader {
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.image-uploader img {
		background: #fff;
		border-radius: 50%;
	}
</style>